import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const SelectCard = ({ name, slug, description, specHtml, image, alt, titleId, ctaId, imageId, ctaLabel }) => (
  <article className="news__item">
    <div className="news__item-content">
      <div className="news__item-date">&nbsp;</div>
      <h2 className="news__item-headline">
        <Link className="news__item-headline-link" to={`/browse-styles/${slug}`} id={titleId}>
          {name}
        </Link>
      </h2>
      <p className="news__item-text">{description}</p>
      {specHtml && (
        <div className="news__item-spec" dangerouslySetInnerHTML={{ __html: specHtml }} />
      )}
      <Link className="news__item-more" to={`/browse-styles/${slug}`} id={ctaId}>
        {ctaLabel}
      </Link>
    </div>
    <div className="news__item-media">
      <Link className="news__item-media-link" to={`/browse-styles/${slug}`} id={imageId}>
        <img className="news__item-media-image" alt={alt} src={image} />
      </Link>
    </div>
  </article>
);

SelectCard.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  specHtml: PropTypes.string,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  ctaId: PropTypes.string,
  imageId: PropTypes.string,
  ctaLabel: PropTypes.string.isRequired,
};

const SelectPage = () => {
  const { find, meta } = usePageContent('select');
  const seo = meta?.seo;
  const intro = find('richText') || {};
  const cardsData = find('collectionCards') || {};
  const footer = find('footerCta') || {};
  const cards = cardsData.cards || [];
  const ctaLabel = cardsData.cardCtaLabel || 'Learn more';

  useTitle(seo?.title || intro.pageTitle || 'Select range');
  useMeta(seo);

  return (
    <div id="content" className={styles.page}>
      <div className={`page-header ${styles.selectHeader}`}>
        <div className="content-holder content-holder--indented">
          <h1 className="page-header__title">{intro.pageTitle || 'Select range'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text">
          {intro.richTextHtml && (
            <div dangerouslySetInnerHTML={{ __html: intro.richTextHtml }} />
          )}
          {cards.map((card, idx) => (
            <SelectCard
              key={card.titleId || `${card.slug}-${idx}`}
              name={card.name}
              slug={card.slug}
              description={card.description}
              specHtml={card.specHtml}
              image={card.image}
              alt={card.alt}
              titleId={card.titleId}
              ctaId={card.ctaId}
              imageId={card.imageId}
              ctaLabel={ctaLabel}
            />
          ))}
          {footer.richTextHtml && (
            <div dangerouslySetInnerHTML={{ __html: footer.richTextHtml }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectPage;
